import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { PlanType } from '../../models/plantype.model';
import { DashboardService } from '../dashboard.service';
import { NotificationBuilder } from '../../shared/notificationBuilder'
import { Feature } from 'src/app/models/feature';
import { PlanService } from 'src/app/services/plan.service';

@Component({
  selector: 'app-admin-plan',
  templateUrl: './admin-plan.component.html',
  styleUrls: ['./admin-plan.component.css']
})
export class AdminPlanComponent implements OnInit {

  constructor(public dashboardService: DashboardService, public planService: PlanService, public ngxSmartModalService: NgxSmartModalService, private notificationBuilder: NotificationBuilder) {
  }

  planList: Array<PlanType> = null
  planModel: PlanType = null
  detailTempList: Array<string> = null
  featureList: Array<Feature> = null
  newDetailModel: string = null
  private _opened: boolean = false;
  isEditPlan: boolean = false;

  private _toggleSidebar() {
    debugger
    this._opened = !this._opened;
  }

  ngOnInit() {
    this.planService.adminGetAllPlans().subscribe(data => {
      this.loadFeatures();
      this.planList = data
      console.log(data);
    })
  }

  editPlan(plan) {
    this.planModel = plan
    this.isEditPlan = true;
    this.ngxSmartModalService.getModal('planModal').open()
    if (this.planModel.details == null)
      this.planModel.details = new Array();
  }

  createPlan() {
    this.isEditPlan = false;
    this.planModel = new PlanType()
    this.ngxSmartModalService.getModal('planModal').open()
    this.planModel.details = new Array();
  }

  savePlan() {
    debugger
    this.planService.savePlan(this.planModel).subscribe(data => {
      if (data) {
        this.notificationBuilder.showNotification('success', 1000, 'Plano alterado com sucesso')
      } else {
        this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a alteração dos dados')
      }
      this.planService.adminGetAllPlans().subscribe(data => {
        this.planList = data
      })
      this.ngxSmartModalService.getModal('planModal').close()
    })
  }

  addDetail(detail) {
    debugger
    this.planModel.details.push(detail)
    this.planModel.newDetail = null
  }

  removeDetail(index, detail) {
    debugger
    this.planModel.details.splice(index, 1);
  }

  loadFeatures() {
    this.planService.adminGetAllFeatures().subscribe(data => {
      debugger
      console.log(data);
      if (data.success) {
        this.featureList = data.data;
      }
    })
  }

  AddRemoveFeature(type) {
    debugger
    if (type == "plus") {
      this.planService.adminAddFeatureToPlanSaffold(this.planModel.id, this.planModel.featureId).subscribe(data => {
        debugger
        console.log(data);
        if (data.success) {
          var feature = this.featureList.find(x => x.id == this.planModel.featureId);
          if (this.planModel.features == null)
            this.planModel.features = [];
          this.planModel.features.push(feature);
          this.notificationBuilder.showNotification('success', 1000, this.planModel.featureId + ' adicionada')
        }
        else {
          this.notificationBuilder.showNotification('danger', 2000, data.error)
        }
      })

    }
    else {
      this.planService.adminRemoveFeatureToPlanSaffold(this.planModel.id, this.planModel.featureId).subscribe(data => {
        debugger
        console.log(data);
        if (data.success) {
          if (this.planModel.features == null)
            this.planModel.features = [];
          this.planModel.features.pop()
          this.notificationBuilder.showNotification('success', 1000, this.planModel.featureId + ' removido')
        }
        else {
          this.notificationBuilder.showNotification('danger', 2000, data.error)
        }
      })

    }
  }
}
